import React, { useEffect, useRef } from 'react';
import {
  Dialog,
  DialogContent,
  DialogDescription,
  DialogFooter,
  DialogTitle,
} from '../ui/Dialog';

const ConfirmModal = ({
  open,
  title,
  message,
  confirmLabel = 'Confirm',
  cancelLabel = 'Cancel',
  variant = 'danger',
  onConfirm,
  onCancel,
}: any) => {
  const confirmRef = useRef<any>(null);

  useEffect(() => {
    if (open && confirmRef.current) {
      confirmRef.current.focus();
    }
  }, [open]);

  const handleOpenChange = (nextOpen) => {
    if (!nextOpen) onCancel?.();
  };

  const confirmClass = variant === 'danger' ? 'btn-outline-danger-mdl' : 'btn-primary-mdl';

  return (
    <Dialog open={open} onOpenChange={handleOpenChange}>
      <DialogContent open={open} showCloseButton={false}>
        <div className="p-6 pt-4">
          <DialogTitle className="text-lg font-semibold text-slate-100">{title}</DialogTitle>
          <DialogDescription className="mt-2 text-sm text-slate-400">{message}</DialogDescription>
        </div>
        <DialogFooter className="p-6 pt-0">
          <button type="button" onClick={onCancel} className="btn-secondary-mdl">
            {cancelLabel}
          </button>
          <button ref={confirmRef} type="button" onClick={onConfirm} className={confirmClass}>
            {confirmLabel}
          </button>
        </DialogFooter>
      </DialogContent>
    </Dialog>
  );
};

export default ConfirmModal;
